export default function LibraryTypeFolder({ item }) {
    const operationGroups = item.operationGroups ?? [];

    return (
        <div className="space-y-4 mt-2">
            <section className="space-y-2">
                <h4 className="text-sm font-semibold">
                    Grupos de operações
                </h4>
                {operationGroups.length > 0 ? (
                    <div className="space-y-1">
                        {operationGroups.map((group) => (
                            <p key={group.value} className="text-sm ">
                                {group.label}
                            </p>
                        ))}
                    </div>
                ) : (
                    <p className="text-sm text-[#6B7280]">
                        Não há grupos vinculados
                    </p>
                )}
            </section>
        </div>
    )
}
